import * as React from "react";
import { Box } from "@mui/material";
import { platformFonts } from "../tickitPlatformTheme";

export default function PlatformAvatar({ initials, bg = "#EDE8F5", color = "#46109B", size = 32 }) {
  return (
    <Box
      sx={{
        width: size,
        height: size,
        borderRadius: "50%",
        bgcolor: bg,
        color,
        display: "flex",
        alignItems: "center",
        justifyContent: "center",
        fontSize: 12,
        fontWeight: 700,
        fontFamily: platformFonts.body,
        flexShrink: 0,
      }}
    >
      {initials}
    </Box>
  );
}
